import { createStore } from "jotai/vanilla";

/**
 * Global Jotai store used across the application.
 * Exported so non-component modules (e.g. Firebase listeners)
 * can update atoms directly.
 */
export const jotaiStore = createStore();

export default jotaiStore;

